import {
  Assets,
  booking,
  dashboard,
  hr,
  medicalstore,
  noteicon1,
  order,
  patient,
  report,
} from '../components/imagepath';
import { PERMISSIONS } from '../constants/permissions';

export const sidebarMenuConfig = [
  {
    id: 'menu-item14',
    className: 'menu-item_14',
    label: 'Dashboard',
    icon: dashboard,
    subItems: [
      {
        label: 'Rooms',
        path: '/room-dashboard',
        permission: PERMISSIONS.ROOMS.DASHBOARD,
        activeClassName: 'admin-dashboard',
      },
      {
        label: 'Dashboard',
        path: '/admin-dashboard',
        permission: PERMISSIONS.DASHBOARD.CLINIC_OPERATIONS_VIEW,
        activeClassName: 'admin-dashboard',
      },
    ],
  },
  {
    id: 'menu-item18',
    className: 'menu-item_18',
    label: 'Bookings',
    icon: booking,
    subItems: [
      {
        label: 'Doctor Consultations',
        path: '/appoinment-list?page=1',
        permission: PERMISSIONS.APPOINTMENTS.VIEW,
        activeClassName: 'admin-dashboard',
      },
      {
        label: 'Treatment',
        path: '/treatment-slot?page=1',
        permission: PERMISSIONS.TREATMENTS.SLOTS,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Detox Programs',
        path: '/solution-slot?page=1',
        permission: PERMISSIONS.SOLUTIONS.SLOTS,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Medi Daycare Rituals',
        path: '/service-slot?page=1',
        permission: PERMISSIONS.SERVICES.SLOTS,
        activeClassName: 'doctor-dashboard',
      },
      // {
      //   label: 'Room slot Booking',
      //   path: '/room-slot?page=1',
      //   permission: PERMISSIONS.ROOMS.SLOTS,
      //   activeClassName: 'doctor-dashboard',
      // },
      {
        label: 'Retreat',
        path: '/detox-retreat-booking?page=1',
        permission: PERMISSIONS.BOOKINGS.DETOX_RETREAT,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Programme',
        path: '/program-booking?page=1',
        permission: PERMISSIONS.BOOKINGS.PROGRAM_BOOKING,
        activeClassName: 'doctor-dashboard',
      },
    ],
  },
  {
    id: 'menu-item19',
    className: 'menu-item_19',
    label: 'Order Management',
    icon: order,
    subItems: [
      {
        label: 'Order & History',
        path: '/order-history?page=1',
        permission: PERMISSIONS.ORDERS.VIEW,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Pending & History',
        path: '/pending-history?page=1',
        permission: PERMISSIONS.ORDERS.PENDING,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Cancelled Orders',
        path: '/cancelled-orders?page=1',
        permission: PERMISSIONS.ORDERS.VIEW,
        activeClassName: 'doctor-dashboard',
      }
    ],
  },
  {
    id: 'menu-item-coupon',
    className: 'menu-item_coupon',
    label: 'Coupon Management',
    icon: noteicon1,
    path: '/coupon-management?page=1',
    permission: PERMISSIONS.COUPONS.VIEW,
    activeClassName: 'coupon-dashboard',
  },
  {
    id: 'menu-item20',
    className: 'menu-item_20',
    label: 'Patient Management',
    icon: patient,
    subItems: [
      {
        label: 'Patients Masterdata',
        path: '/patient-list?page=1',
        permission: PERMISSIONS.PATIENTS.VIEW,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Patients Verification',
        path: '/verify-case',
        permission: PERMISSIONS.CASE_MANAGEMENT.VERIFY,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Members Verification',
        path: '/verify-member',
        permission: PERMISSIONS.MEMBERS.VERIFICATION,
        activeClassName: 'doctor-dashboard',
      },
      // {
      //   label: 'Patients Confirmation',
      //   path: '/patientconfirmation',
      //   permission: PERMISSIONS.PATIENTS.CONFIRMATION,
      //   activeClassName: 'doctor-dashboard',
      // },
      // {
      //   label: 'Assigned Doctor',
      //   path: '/assigneddoctor',
      //   permission: PERMISSIONS.DOCTORS.ASSIGNMENT,
      //   activeClassName: 'doctor-dashboard',
      // },
    ],
  },
  {
    id: 'menu-item21',
    className: 'menu-item_21',
    label: 'Medical Store',
    icon: medicalstore,
    subItems: [
      {
        label: 'Dispense Medicines',
        path: '/medical-store?page=1',
        permission: PERMISSIONS.MEDICAL_STORE.VIEW,
        activeClassName: 'admin-dashboard',
      },
      {
        label: 'Medicines Dispensing History',
        path: '/medical-history?page=1',
        permission: PERMISSIONS.MEDICAL_STORE.VIEW,
        activeClassName: 'doctor-dashboard',
      },
    ],
  },
  {
    id: 'menu-item28',
    className: 'menu-item_28',
    label: 'Room Management',
    icon: order,
    subItems: [
      {
        label: 'Occupancy',
        path: '/occupancy?page=1',
        // permission: PERMISSIONS.ORDERS.VIEW,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Rooms',
        path: '/new-room?page=1',
        // permission: PERMISSIONS.ORDERS.PENDING,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Room Types',
        path: '/room-types?page=1',
        // permission: PERMISSIONS.ORDERS.PENDING,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Room Prices',
        path: '/room-prices?page=1',
        // permission: PERMISSIONS.ORDERS.VIEW,
        activeClassName: 'doctor-dashboard',
      },
      {
        label: 'Bookings',
        path: '/room-booking?page=1',
        // permission: PERMISSIONS.ORDERS.VIEW,
        activeClassName: 'doctor-dashboard',
      }
    ],
  },
  {
    id: 'menu-item22',
    className: 'menu-item_22',
    label: 'HR',
    icon: hr,
    subItems: [
      {
        label: 'Leave Management',
        path: '/leaves?page=1',
        permission: PERMISSIONS.LEAVES.VIEW,
        activeClassName: 'admin-dashboard',
      },
      {
        label: 'Prakruti Holidays',
        path: '/holidays?page=1',
        permission: PERMISSIONS.HOLIDAYS.VIEW,
        activeClassName: 'doctor-dashboard',
      },
    ],
  },
  {
    id: 'menu-item23',
    className: 'menu-item_23',
    label: 'Public Relations',
    icon: booking,
    subItems: [
      {
        label: "Birthdays/Anniversaries",
        path: '/birthday-list',
        permission: PERMISSIONS.BIRTHDAY_FOLKS.VIEW,
        activeClassName: 'admin-dashboard',
      },
      {
        label: 'Gallery List',
        path: '/gallery-listing',
        permission: PERMISSIONS.GALLERY.VIEW,
        activeClassName: 'patient-dashboard',
      },
      {
        label: 'Detox Retreat',
        path: '/detoxretreat-list?page=1',
        permission: PERMISSIONS.DETOX_RETREAT.VIEW,
        activeClassName: 'patient-dashboard',
      },
    ],
  },
  {
    id: 'menu-item24',
    className: 'menu-item_24',
    label: 'Reports',
    icon: report,
    subItems: [
      {
        label: 'Order Report',
        path: '/order-report',
        permission: PERMISSIONS.REPORTS.ORDER_REPORTS,
        activeClassName: 'admin-dashboard',
      },
    ],
  },
  // {
  //   id: 'menu-item30',
  //   className: 'menu-item_30',
  //   label: 'Therapist Allocation',
  //   icon: report,
  //   subItems: [
  //     {
  //       label: 'Therapist History',
  //       path: '/therapist-history',
  //       permission: PERMISSIONS.THERAPIST.HISTORY,
  //       activeClassName: 'admin-dashboard',
  //     },
  //   ],
  // },
  {
    id: 'menu-item25',
    className: 'menu-item_25',
    label: 'Software Management',
    icon: hr,
    subItems: [
      {
        id: 'menu-item26',
        className: 'menu-item_26',
        label: 'Manage Access',
        isSubmenu: true,
        subItems: [
          {
            label: 'Staff',
            path: '/staff-list?page=1',
            permission: PERMISSIONS.STAFF.VIEW,
            activeClassName: 'admin-dashboard',
          },
          {
            label: 'Roles',
            path: '/roles?page=1',
            permission: PERMISSIONS.ADMIN.ROLES_VIEW,
            activeClassName: 'doctor-dashboard',
          },
          {
            label: 'Permissions',
            path: '/permissions?page=1',
            permission: PERMISSIONS.ADMIN.PERMISSIONS_VIEW,
            activeClassName: 'patient-dashboard',
          },
        ],
      },
      {
        id: 'menu-item27',
        className: 'menu-item_27',
        label: 'Master Data',
        isSubmenu: true,
        subItems: [
          {
            id: 'menu-item28',
            className: 'menu-item_28',
            label: 'Frontend',
            icon: Assets,
            isSubmenu: true,
            subItems: [
              // {
              //   label: 'Room Details',
              //   path: '/room?page=1',
              //   permission: PERMISSIONS.ROOMS.VIEW,
              //   activeClassName: 'doctor-dashboard',
              // },
              {
                label: 'Celebrities',
                path: '/celebrity-list?page=1',
                permission: PERMISSIONS.CELEBRITIES.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'FAQ',
                path: '/faq-list?page=1',
                permission: PERMISSIONS.FAQ.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Patient Testimonial',
                path: '/patient-testimonial-list?page=1',
                permission: PERMISSIONS.TESTIMONIALS.PATIENT_TESTIMONIALS,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Testimonial Links',
                path: '/testimonial-link-list?page=1',
                permission: PERMISSIONS.TESTIMONIALS.LINKS,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Treatments',
                path: '/treatment-list?page=1',
                permission: PERMISSIONS.TREATMENTS.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Programmes',
                path: '/programme-list?page=1',
                permission: PERMISSIONS.PROGRAMS.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Detox Programs',
                path: '/solution-list?page=1',
                permission: PERMISSIONS.SOLUTIONS.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Medi Daycare Rituals List',
                path: '/service-list?page=1',
                permission: PERMISSIONS.SERVICES.VIEW,
                activeClassName: 'admin-dashboard',
              },
              {
                label: 'Gallery List',
                path: '/gallery-listing',
                permission: PERMISSIONS.GALLERY.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Detox Retreat',
                path: '/detoxretreat-list?page=1',
                permission: PERMISSIONS.DETOX_RETREAT.VIEW,
                activeClassName: 'patient-dashboard',
              },
            ],
          },
          {
            id: 'menu-item29',
            className: 'menu-item_29',
            label: 'Backend',
            icon: Assets,
            isSubmenu: true,
            subItems: [
              {
                label: 'Do & Donts',
                path: '/do-and-donts?page=1',
                permission: PERMISSIONS.MASTER_DATA.DO_DONTS,
                activeClassName: 'admin-dashboard',
              },
              {
                label: 'Treatment Protocol',
                path: '/treatmentprotocol-list',
                permission: PERMISSIONS.TREATMENTS.PROTOCOLS,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Virechan',
                path: '/virechan?page=1',
                permission: PERMISSIONS.MASTER_DATA.VIRECHAN.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Therapist Shifts',
                path: '/shifts?page=1',
                permission: PERMISSIONS.MASTER_DATA.SHIFTS.VIEW,
                activeClassName: 'doctor-dashboard',
              },
              {
                label: 'Exercise',
                path: '/exercise?page=1',
                permission: PERMISSIONS.MASTER_DATA.EXERCISE.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Member Ship',
                path: '/member-ship?page=1',
                permission: PERMISSIONS.MASTER_DATA.MEMBERSHIP.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Medicine',
                path: '/medicine?page=1',
                permission: PERMISSIONS.MASTER_DATA.MEDICINE.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Diet Plan',
                path: '/diet-plan?page=1',
                permission: PERMISSIONS.MASTER_DATA.DIET_PLAN.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Price Table',
                path: '/price-table?page=1',
                permission: PERMISSIONS.PRICE_TABLES.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'App Config',
                path: '/app-config?page=1',
                permission: PERMISSIONS.APP_CONFIG.VIEW,
                activeClassName: 'patient-dashboard',
              },
              {
                label: 'Therapist Count',
                path: '/therapist-count',
                permission: PERMISSIONS.MASTER_DATA.THERAPIST_COUNT.VIEW,
                activeClassName: 'patient-dashboard',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'menu-item26',
    className: 'menu-item_26',
    label: 'Simulation OTP',
    icon: noteicon1,
    path: '/simulation-otp',
    permission: PERMISSIONS.SIMULATION_OTP.VIEW,
    activeClassName: 'patient-dashboard',
  },
];
